(function () {
  function parseSampleMap(button) {
    const raw = button.getAttribute('data-sample-map');
    if (!raw) return {};

    try {
      return JSON.parse(raw);
    } catch (error) {
      return {};
    }
  }

  /** Resolves event.target to an Element so closest() is available (text nodes do not have it). */
  function eventTargetElement(target) {
    return target instanceof Element ? target : target.parentElement;
  }

  function updateSampleTriggerFromKey(button, sampleKey) {
    if (!button || !sampleKey) return;

    const holder = button.closest('.quick-add__holder--sample');
    const sampleMap = parseSampleMap(button);
    const sampleEntry = sampleMap[sampleKey];

    if (!sampleEntry || !sampleEntry.id) {
      if (holder) holder.hidden = true;
      return;
    }

    if (holder) holder.hidden = false;
    button.setAttribute('data-variant-id', String(sampleEntry.id));
    button.setAttribute('data-sample-active-key', sampleKey);
  }

  function initSampleTrigger(button) {
    const sampleMap = parseSampleMap(button);
    const mapKeys = Object.keys(sampleMap);
    if (!mapKeys.length) return;

    const activeKey = button.getAttribute('data-sample-active-key');
    if (activeKey && sampleMap[activeKey]) {
      updateSampleTriggerFromKey(button, activeKey);
      return;
    }

    updateSampleTriggerFromKey(button, mapKeys[0]);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sample-trigger]').forEach((button) => {
      initSampleTrigger(button);
    });
  });

  ['mouseenter', 'focusin', 'click'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        const swatch = eventTargetElement(event.target)?.closest('[data-swatch-button]');
        if (!swatch) return;

        const gridItem = swatch.closest('[data-grid-item]');
        const button = gridItem?.querySelector('[data-sample-trigger]');
        if (!button) return;

        const sampleKey = swatch.getAttribute('data-sample-key');
        updateSampleTriggerFromKey(button, sampleKey);
      },
      true
    );
  });
})();
